import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {Observable} from 'rxjs';
import {localstorageKeyAppId, localstorageKeyThemes, SettingsProvider} from '@orga-app/settings/settings.service';
import {select, Store} from '@ngrx/store';
import {TranslateService} from '@ngx-translate/core';
import {getTheme} from '@orga-app/settings/reducer';
import {SafeUrl} from '@angular/platform-browser';
import {ThemeFileGeladenAction} from '@orga-app/settings/actions';
import {IonInput} from '@ionic/angular';
import {getError} from '@orga-app/auth/reducer';
import {AuthService} from '@orga-app/auth';
import {Settings} from '@orga-app/settings';
import {EnvironmentOptions} from '@orga-app/env';
import {ActivatedRoute, Router} from '@angular/router';
import {filter, map} from 'rxjs/operators';
import {AuthLogoutAction} from '@orga-app/auth/actions';

declare const originMappingList;
declare const window;

@Component({
    selector: 'page-login',
    templateUrl: 'login.page.html',
    styleUrls: ['./login.page.scss'],
})
export class LoginPage implements OnInit {

    @ViewChild('userInput', {static: false}) userInput: IonInput;
    @ViewChild('passwordInput', {static: false}) passwordInput: IonInput;
    registerCredentials = {email: '', password: ''};

    email: string;
    password: string;
    public settings$: Observable<Settings>;
    themeDefault$: Observable<Settings>;
    logoSVG$: Observable<SafeUrl>;
    logoHeaderSVG$: Observable<SafeUrl>;
    loginBackground$: Observable<any>;
    error$: Observable<string>;
    error2$: Observable<string>;

    private aiName = 'LoginPage';

    public showLogout$: Observable<boolean>;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private authService: AuthService,
        private settingsProvider: SettingsProvider,
        public translate: TranslateService,
        private store: Store<any>,
        public envi: EnvironmentOptions
    ) {
        console.log('login page envi:', envi);
        this.translate.setDefaultLang('de');
        this.translate.use('de');
        this.themeDefault$ = this.settingsProvider.getThemeDefault();
        this.logoSVG$ = this.settingsProvider.getLogoSVG();
        this.logoHeaderSVG$ = this.settingsProvider.getLogoHeaderSVG();
        this.loginBackground$ = this.settingsProvider.getLoginBackground();
        this.settings$ = this.store.pipe(select(getTheme));

        //   this.error$ = this.store.pipe(select(getError));

        // PREMIUM KUNDEN (EIGENE URL)
        const identifier = (localStorage.getItem(localstorageKeyAppId) !== null && localStorage.getItem(localstorageKeyAppId) !== undefined) ? localStorage.getItem(localstorageKeyAppId) : window.origin;
        if (originMappingList[identifier]) {
            const themes = JSON.parse(localStorage.getItem(localstorageKeyThemes));
            if (themes !== null) {
                this.store.dispatch(new ThemeFileGeladenAction(themes, originMappingList[identifier]));
            }
        }

        // TODO: falls die nachrichten über toast gehen sollen, dann den app.effects anpassen
        authService.lastProviderError$
            .pipe(
                filter(e => e !== null && e !== undefined),
            )
            .subscribe(pe => {
                if (pe != null) {
                    console.error('login page: error from authService', pe);
                }
            });

        this.error$ = authService.lastProviderError$
            .pipe(
                filter(e => e !== null && e !== undefined),
                map(x => {

                    let titel = 'Bitte erneut anmelden.';

                    if (x.event_type === 'session_terminated') {
                        titel = 'Die Sitzung wurde serverseitig beendet, bitte erneut anmelden.';
                    }

                    if (x.event_type === 'session_error') {
                        titel = 'Sitzung fehlerhaft, bitte erneut anmelden.';
                    }

                    if (x.event_type === 'token_error') {
                        titel = 'Anmelde-Token fehlerhaft, bitte erneut anmelden.';
                    }

                    if (x.event_type === 'silent_refresh_timeout') {
                        titel = 'Die Aktualisierung deiner Anmeldedaten ist fehlgeschlagen. Bitte melde dich erneut an.';
                    }

                    if (x.error && x.error === 'interaction_required' && x.error_description && x.error_description.indexOf('AADSTS16000') > -1) {
                        return 'Du bist mit mehreren Benutzerkonten bei Microsoft angemeldet. Bitte melde dich mit einem Konto ab.';
                    }

                    // das ist der standard type. error beim code und eine interaction erforderlich
                    if (x.event_type === 'code_error' && x.error && x.error === 'interaction_required') {
                        return null;
                    }


                    return titel;
                })
            );

        this.error2$ = authService.lastProviderError$
            .pipe(
                filter(e => e !== null && e !== undefined),
                map(pe => pe.event_type + ' | ' + pe.error + ' | ' + pe.error_description)
            );


        this.showLogout$ = authService.lastProviderError$
            .pipe(
                filter(e => e !== null && e !== undefined && e.error_description !== null && e.error_description !== undefined),
                map(pe => pe.error_description.indexOf('AADSTS16000') > -1)
            );
    }

    ngOnInit(): void {

    }

    public login() {
        this.authService.login();
    }

    public logout() {
        // await this.store.dispatch(new AuthLogoutAction());
        console.debug('login page: logout');

        this.authService.logout2();
    }

    ionViewWillEnter() {

    }

}
